"use client";

import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import { BundleProductDescription } from "./BundleProductDescription/BundleProductDescription";
import { BundleProductSpecification } from "./BundleProductSpecification/BundleProductSpecification";
import styles from "./BundleProductAccordion.module.scss";
import { RetiredStaticBundleComponent } from "../../../types/types";

type Props = {
  bundleComponent: RetiredStaticBundleComponent;
};

export const BundleProductAccordion = ({ bundleComponent }: Props) => {
  return (
    <>
      <div data-testid="bundleProduct:accordion">
        <Accordion
          id="bundle-accordion-description"
          className={styles.accordion}
          data-testid="bundleAccordion:description"
          label="Product description"
          animated={undefined}
          animationDuration={undefined}
          onStateChange={undefined}
          size="M"
        >
          <BundleProductDescription
            product={bundleComponent.variant.parentProduct}
          />
        </Accordion>
        <Accordion
          id="bundle-accordion-specification"
          className={styles.accordion}
          data-testid="bundleAccordion:specification"
          label="Product specification"
          animated={undefined}
          animationDuration={undefined}
          onStateChange={undefined}
          size="M"
        >
          <BundleProductSpecification bundleComponent={bundleComponent} />
        </Accordion>
      </div>
    </>
  );
};
